const TRACKERS =  {
   PROJECT_EXPORTED: "Project-Exported",
   EXPORT_INITIATED: "Export-Initiated",
   EXPORT_BTN_YOUTUBE_CLICKED: "Export-Btn-Youtube-Clicked",
   EXPORT_BTN_DOWNLOAD_CLICKED: "Export-Btn-Download-Clicked",
}

export default TRACKERS;